export class Environment {
    static getGroupPrefix() {
        return process.env.REACT_APP_GROUP_PREFIX || '';
    }

    static getBasePath() {
        return process.env.REACT_APP_BASE_PATH || '/';
    }

    static getUploadAPI() {
        return process.env.REACT_APP_XDOCK_UPLOAD_API || ''; 
    }

    static getValidationAPI() {
        return process.env.REACT_APP_XDOCK_VALIDATION_API || '';
    }

    static getJsonUploadIN02API() {
        return process.env.REACT_APP_JSON_UPLOAD_IN02_API || '';
    }

    static getJsonValidationIN02API() {
        return process.env.REACT_APP_JSON_VALIDATION_IN02_API || '';
    }

    static getValidationIN02API() {
        return process.env.REACT_APP_VALIDATION_IN02_API || '';
    }
    static getUploadIN02API() {
        return process.env.REACT_APP_UPLOAD_IN02_API || '';
    }

    static getDashboardAPI() {
        return process.env.REACT_APP_DASHBOARD_API || '';
    }
	
	static getJsonValidationAPI() {
        return process.env.REACT_APP_JSON_VALIDATION_API || '';
    }

    static getJsonUploadAPI() {
        return process.env.REACT_APP_JSON_UPLOAD_API || '';
    }

    static getStoreOrderPublishAPI() {
        return process.env.REACT_APP_STORE_ORDER_PUBLISH_API || '';
    }
    
    static getStoreOrderMsgCountAPI() {
        return process.env.REACT_APP_STORE_ORDER_MSG_COUNT_API || '';
    }

    static getStoreOrderDcNamesAPI() {
        return process.env.REACT_APP_STORE_ORDER_DC_NAMES_API || '';
    }

    static getStoreOrderHistoryAPI() {
        return process.env.REACT_APP_STORE_ORDER_HISTORY_API || '';
    }

    // Custom IN02 APIs
    static getJsonUploadCustomIN02API() {
        return process.env.REACT_APP_JSON_UPLOAD_CUSTOM_IN02_API || '';
    }

    static getJsonValidationCustomIN02API() {
        return process.env.REACT_APP_JSON_VALIDATION_CUSTOM_IN02_API || '';
    }

    static getValidationCustomIN02API() {
        return process.env.REACT_APP_VALIDATION_CUSTOM_IN02_API || '';
    }

    static getUploadCustomIN02API() {
        return process.env.REACT_APP_UPLOAD_CUSTOM_IN02_API || '';
    }

    // Combined IN02 APIs
    static getJsonValidationIN02CombinedAPI() {
        return process.env.REACT_APP_JSON_VALIDATION_IN02_COMBINED_APIS || '';
    }

    static getJsonUploadIN02CombinedAPI() {
        return process.env.REACT_APP_JSON_UPLOAD_IN02_COMBINED_API || '';
    }

    static getValidationIN02CombinedAPI() {
        return process.env.REACT_APP_VALIDATION_IN02_COMBINED_API || '';
    }

    static getUploadIN02CombinedAPI() {
        return process.env.REACT_APP_UPLOAD_IN02_COMBINED_API || '';
    }

    static getCustomIN02DCList() {
        const dcListString = process.env.REACT_APP_CUSTOM_IN02_DCNAME_LISTS || '';
        return dcListString ? dcListString.split(',').map(dc => dc.trim()) : [];
    }

	 static getDockDoorCaseCheckDCList() {
        const dcListString = process.env.REACT_APP_DOCK_DOOR_CASE_CHECK_DCNAME_LIST || '';
        return dcListString ? dcListString.split(',').map(dc => dc.trim()) : [];
    }

    static getCombinedIN02DCList() {
        const dcListString = process.env.REACT_APP_IN02_COMBINED_DCNAME_LIST || '';
        return dcListString ? dcListString.split(',').map(dc => dc.trim()) : [];
    }

    static getManualAPI() {
        return process.env.REACT_APP_MANUAL_API || '';
    }

    static getFetchCsvFilesAPI() {
        return process.env.REACT_APP_FETCH_CSV_FILES_API || '';
    }

    static getRouteFetchAPI() {
        return process.env.REACT_APP_ROUTE_FETCH_API || '';
    }

    static getRouteComboAPI() {
        return process.env.REACT_APP_ROUTE_COMBO_API || '';
    }

    static getRouteViewPayloadAPI() {
        return process.env.REACT_APP_ROUTE_VIEW_PAYLOAD_API || '';
    }

    static getRouteSplitAPI() {
        return process.env.REACT_APP_ROUTE_SPLIT_API || '';
    }

    static getRouteReplayAPI() {
        return process.env.REACT_APP_ROUTE_REPLAY_API || '';
    }
    static getGroupDropDownAPI() {
        return process.env.REACT_APP_GROUP_DROPDOWN_API || '';
    }

    static  getOrganisationDataAPI() {
        return process.env.REACT_APP_ORGANISATION_DATA_API|| '';
    }

    static submitFileAPI() {
        return process.env.REACT_APP_SUBMIT_FILE_API || '';
    }

    static getMandatoryFieldsAPI() {
        return process.env.REACT_APP_MANDATORY_FIELDS_API || '';
    }

    static getFieldTypeAPI() {
        return process.env.REACT_APP_FIELD_TYPE_API || '';
    }

    static getDoorStatusesAPI() {
        return process.env.REACT_APP_DOOR_STATUSES_API || '';
    }

    static getTableHeadersAPI() {
        return process.env.REACT_APP_TABLE_HEADERS_API || '';
    }

    static getSubmitTableDataAPI() {
        return process.env.REACT_APP_SUBMIT_TABLE_DATA_API || '';
    }

    static getStopStatusAPI() {
        return process.env.REACT_APP_STOP_STATUS_API || '';
    }

    static getFetchBananaRoomsAPI() {
        return process.env.REACT_APP_FETCH_BANANA_ROOMS_API || '';
    }

    static updateNewSeqAPI() {
        return process.env.REACT_APP_UPDATE_NEW_SEQ_API || '';
    }
    static getSelfServiceAppHost() {
        return process.env.REACT_APP_HOST || '';
    }

    static getExecuteBatchAPI() {
        return process.env.REACT_APP_EXE_BATCH_API || '';
    }

	
	static getHubUsersAPI() {
        return process.env.REACT_APP_HUB_USERS_API || '';
    }
	
    static getHubGroupsAPI() {
        return process.env.REACT_APP_HUB_GROUPS_API || '';
    }
	
    static getHubGroupListAPI() {
        return process.env.REACT_APP_HUB_GROUPLIST_API || '';
    }
	
    static getHubCapabilitiesAPI() {
        return process.env.REACT_APP_HUB_CAPABILITIES_API || '';
    }
	
    static getHubGroupCapabilitiesAPI() {
        return process.env.REACT_APP_HUB_GROUP_CAPABILITIES_API || '';
    }
	
    static getHubUserPermissionsAPI() {
        return process.env.REACT_APP_HUB_USER_PERMISSIONS_API || '';
    }
	
    static getHubUserPreferencesAPI() {
        return process.env.REACT_APP_HUB_USER_PREFERENCES_API || '';
    }
    
    static saveA3FormAPI() {
        return process.env.REACT_APP_SAVE_A3_FORM || '';
    }

    static fetchA3FormsAPI() {
        return process.env.REACT_APP_FETCH_A3_FORMS || '';
    }

    static viewA3FormAPI() {
        return process.env.REACT_APP_VIEW_A3_FORM || '';
    }

    static editA3FormAPI() {
        return process.env.REACT_APP_EDIT_A3_FORM || '';
    }

    static deleteA3FormAPI() {
        return process.env.REACT_APP_DELETE_A3_FORM || '';
    }
}

export default Environment;
